module.exports = __webpack_public_path__ + "img/antes_despues_105.69a51ca1.png";